import mapConversationTypeToConversationItem from '../../store-factory/mapConversationTypeToConversationItem';
import mapConversationTypeToConversationRelation from '../../store-factory/mapConversationTypeToConversationRelation';
import { ObservableMap } from 'mobx';
import { ConversationItem, TableView, TableViewConversationRelation } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getTableToRowRelationKey from 'owa-mail-list-store/lib/utils/getTableToRowRelationKey';
import ConversationType from 'owa-service/lib/contract/ConversationType';
import { action, select } from 'satcheljs/lib/legacy';

export interface AddOrUpdateConversationDataState {
    conversationItems: ObservableMap<string, ConversationItem>;
    tableViewConversationRelations: ObservableMap<string, TableViewConversationRelation>;
}

/**
 * Adds or updated the conversation in the tableView, tableViewConversationRelations
 * This is called whenever a data is fetched from the server and is being stored. This is also called when
 * a rowAdd or rowModified notificaiton occurs
 * @param conversation to add or update
 * @param tableId where to add or update the conversation
 * @param state for unit testing
 */
export default select<AddOrUpdateConversationDataState>({
    conversationItems: () => listViewStore.conversationItems,
    tableViewConversationRelations: () => listViewStore.tableViewConversationRelations,
})(
    action('addOrUpdateConversationData')(function addOrUpdateConversationData(
        conversation: ConversationType,
        tableView: TableView,
        state?: AddOrUpdateConversationDataState
    ) {
        const { conversationItems, tableViewConversationRelations } = state;
        const conversationId = conversation.ConversationId.Id;
        const tableConversationRelationKey = getTableToRowRelationKey(
            conversation.InstanceKey,
            tableView.id
        );

        const conversationItem = mapConversationTypeToConversationItem(conversation, tableView);

        conversationItems.set(conversationId, conversationItem);

        // Create or update the relation object
        const newRelation = mapConversationTypeToConversationRelation(conversation, tableView);
        tableViewConversationRelations.set(tableConversationRelationKey, newRelation);
    })
);
